import "./Promos.css";

const promos = () => {
  return (
    <div className="promo-text-container">
      <p className="p-text">promos & paquetes</p>
      <p className="p-text">diferentes cada mes especiales para ti</p>
      <img className="promo-text-img" src="isotipo b.png" alt="promo" />
    </div>
  );
};

export default promos;
